// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1188px) {
  .payment-stepper-cart {
    width: 80%;
  }
}

@media (max-width: 1173px) {
  .payment-stepper-cart {
    width: 90%;
  }

  .quickvee-payment-component-content {
    padding-left: 0;
    padding-right: 0;
  }
}

@media (max-width: 1035px) {
  .payment-stepper-cart {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .payment-stepper-cart {
    display: flex !important;
    flex-wrap: wrap;
  }

  .payment-stepper-cart > .payment-stepper-wishlist-item {
    width: 100%;
  }

  .payment-stepper-cart > .payment-stepper-checkout-item {
    width: 100%;
    margin-bottom: 20px;
  }

  .payment-stepper-cart > .payment-stepper-customer-detail-section {
    width: 100%;
  }

  .payment-all-cart-items.overflowed {
    padding: 0;
    overflow: hidden;
  }

  .quickvee-payement-stepper > span {
    font-size: clamp(12px, 2px + 2.1783vw, 18px) !important;
  }

  .quickvee-payement-stepper {
    padding: 20px 0px;
    /* margin-bottom: 20px; */
  }

  .payment-stepper-cart
    > .payment-stepper-wishlist-item
    > .payment-all-cart-items {
    height: unset !important;
    max-height: unset !important;
  }

  .payment-stepper-cart > .payment-stepper-customer-detail-section {
    border-right: 0;
  }

  /* .custom-file-upload-input {
        width: 90% !important;
    } */
  .payment-delivery-payment-info-section {
    height: unset;
  }

  .payment-stepper-cart > .payment-stepper-wishlist-item {
    border-right: 0;
  }

  #modal-modal-description {
    overflow-x: unset;
  }

  .payment-stepper-cart > .payment-stepper-customer-detail-section {
    padding: 0;
  }

  .payment-delivery-section {
    margin-bottom: 20px;
  }
  .payment-stepper-checkout-item {
    padding-top: 10px !important;
  }

  .payment-stepper-customer-detail-section {
    padding: 0 20px !important;
  }

  .payment-stepper-cart
    > .payment-stepper-wishlist-item
    > .payment-all-cart-items {
    margin: 0 !important;
  }

  .payment-stepper-single-billing-info-detail {
    padding-top: 20px;
  }

  .payment-delivery-payment-info-section {
    margin-bottom: 10px;
  }

  .profile-page-user-data-button {
    padding-left: 11px;
  }

  .payment-card-details-add-section > div {
    /* width: 100% !important; */
    margin-bottom: 15px;
  }

  .card-expiry-date {
    max-width: 100% !important;
    bottom: -17px !important;
  }
}

/* add css by priya */
.MuiPaper-root::-webkit-scrollbar {
  width: 3px;
}
.MuiPaper-root::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;

  cursor: pointer;
}

/* Handle */
.MuiPaper-root::-webkit-scrollbar-thumb {
  background: #3e85f8;
  border-radius: 10px;
  cursor: pointer;
  -webkit-transition: background 0.3s ease-in-out;
  transition: background 0.3s ease-in-out;
  outline: 1px solid #fff;
}

/* Handle on hover */
.MuiPaper-root::-webkit-scrollbar-thumb:hover {
  background: #0a64f9;
  cursor: pointer !important;
}

@media (max-width: 604px) {
  .payment-card-details-add-section > div {
    width: 100% !important;
  }
}

@media (max-width: 480px) {
  .top-content p {
    font-family: QuicksandBold !important;
    font-size: 16px;
    font-weight: 400 !important;
  }

  /* .payment-card-details-add-section>div{
        width: 100% !important;
        margin-bottom: 15px;
    } */

  /* .css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input {
        padding: 10px 10px !important;
    } */

  .MobileViewPaymentWishlist-option-title {
    font-weight: 500 !important;
    padding-left: 5px;
    margin-bottom: 5px;
  }

  .payment-stepper-cart > .payment-stepper-wishlist-item {
    width: 100%;
  }

  /* font-size: clamp(12px, 0.05px + 5.1783vw, 20px) !important; */

  .payment-stepper-cart > .payment-stepper-checkout-item {
    width: 100%;
    margin-bottom: 20px;
    /* box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px; */
  }

  .payment-stepper-cart > .payment-stepper-wishlist-item {
    padding: 0;
  }

  .payment-page-wishlist-cart-items {
    margin-top: 5px;
    box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px,
      rgba(17, 17, 26, 0.05) 0px 8px 32px;
  }

  .quickvee-payment-component-content {
    padding: 0;
  }

  .payment-page-wishlist-cart-items {
    border-radius: 0;
    border: 0;
  }

  .id-card-detail-image {
    width: 100% !important;
  }

  .custom-file-upload-input {
    width: 100% !important;
  }

  .payment-billing-inputs-div {
    display: flex !important;
    flex-wrap: wrap !important;
  }

  .payment-billing-input-outer-div {
    width: 100%;
  }

  .payment-billing-city-state-update-inputs {
    display: flex !important;
    gap: 2 !important;
  }

  .payment-billing-city-state-update-inputs > div:first-child {
    margin-right: 10px;
    width: 100%;
  }

  .payment-billing-input-outer-div {
    position: relative;
    margin-top: 0px !important;
    margin-bottom: 15px;
  }

  .quickvee-payement-stepper > span {
    margin: 0 5px;
  }

  .css-10botns-MuiInputBase-input-MuiFilledInput-input {
    padding-top: 20px;
  }
}

.payment-page-wishlist-item-content > .middle-content {
  width: 100% !important;
}

.payment-page-wishlist-item-content
  > .middle-content
  > .increment-decremnt-button
  > span {
  margin: unset;
}

.payment-page-wishlist-item-content
  > .middle-content
  > .increment-decremnt-button
  button:disabled {
  background: #80aef7;
}

.payment-page-wishlist-item-content
  > .middle-content
  > .increment-decremnt-button
  button {
  border: none;
  background: #0a64f9;
  border-radius: 4px;
  color: #fff;
  padding: 6px 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.payment-page-wishlist-item-content > .bottom-dropdowns-for-categories > div {
  margin-bottom: 10px !important;
  padding: 0px 3px;
  margin-right: 0;
  width: unset() !important;
  padding: 0 5px !important;
}

.billing-info-delivery-address-update-form > div:nth-child(2) {
  margin: 0px 0px !important;
}

.payment-delivery-address-section
  > .bottom-section-of-payment-delivery-address
  > .payment-delivery-single-delivery-address {
  margin: 4px -4px !important;
}

.payment-stepper-cart
  > .payment-stepper-checkout-item
  > .payment-stepper-checkout-item-top {
  font-size: clamp(12px, 0.05px + 4.1783vw, 20px) !important;
}

.payment-billing-customer-form > h1 {
  margin-bottom: 12px;
  font-size: clamp(12px, 0.05px + 4.1783vw, 20px) !important;
}

.payment-delivery-section > span {
  font-size: clamp(12px, 0.05px + 4.1783vw, 20px) !important;
}

.payment-delivery-payment-info-section > span {
  font-size: clamp(12px, 0.05px + 4.1783vw, 20px) !important;
}

.payment-delivery-address-section
  > .head-section-of-payment-delivery-address
  > span {
  font-size: clamp(12px, 0.05px + 4.1783vw, 20px) !important;
}

.payment-radio-heading span:nth-child(2) {
  font-size: clamp(12px, 0.05px + 4.1783vw, 16px) !important;
}

.css-ahj2mt-MuiTypography-root {
  /* font-size: clamp(12px, 0.05px + 3.1783vw, 16px) !important; */
}

.modal-main-button {
  font-size: clamp(12px, 0.05px + 3.1783vw, 14px) !important;
}

.select-delivery-hour-and-date label {
  /* font-size: clamp(14px, 0.05px + 3.1783vw, 14px) !important; */
}

.modal-form-single-input label {
  font-size: clamp(10px, 0.05px + 3.1783vw, 14px) !important;
}

.css-1ff8729-MuiInputBase-root-MuiFilledInput-root {
  font-size: clamp(14px, 0.05px + 2.6783vw, 14px) !important;
}

.stateDropdown .modal-form-single-input {
  font-size: clamp(10px, 0.05px + 2.6783vw, 14px) !important;
}

.payment-stepper-cart
  > .payment-stepper-checkout-item
  > .payment-stepper-checkout-content
  > .quickvee-checkout-final-amount {
  margin: 15px 0 15px 0 !important;
}

.payment-stepper-cart
  > .payment-stepper-wishlist-item
  > .payment-stepper-wishlist-item-topper {
  margin-top: 20px;
}

.payment-stepper-wishlist-item {
  margin-bottom: 10px;
}

@media (min-width: 768px) {
  .payment-stepper-checkout-item-top {
    margin-top: 20px;
  }
}

.payment-billing-input-outer-div {
  position: relative;
  margin-top: 0px !important;
  margin-bottom: 15px;
}

.input-error {
  position: absolute;
  bottom: -20px;
  left: 0;
  padding-left: 0;
  /* width: 80px; */
  /* padding-right: 30px; */
  height: 15px;
}

.payment-billing-input-outer-div-for-all {
  margin: 0 !important;
}

.top-bar-button {
  padding-left: 19px !important;
  min-width: 0 !important;
  padding: 0 !important;
}

.css-1e6y48t-MuiButtonBase-root-MuiButton-root {
  /* padding: 8.76px 0px !important; */
  /* height: 44px; */
}

.payment-card-details-add-section-single-item {
  position: relative !important;
}

.cvv {
  position: relative !important;
}

.card-expiry-date {
  position: absolute;
  /* bottom: -30px; */
  left: 0;
  /* font-size: clamp(2px, 0.05px + 2.8783vw, 8px) !important; */
  max-width: 100px;
}

/* @media (max-width: 392px) {
    .cvv-input{
        bottom: -29px;
    }
} */

.choose-date-on-payment {
  position: relative !important;
}

.choose-time-on-payment {
  position: relative !important;
}

.css-1xhypcz-MuiStack-root > .MuiTextField-root {
  /* min-width: unset !important; */
}

.custom-file-upload-input {
  position: relative;
}

.image_input_error {
  left: 0;
}

@media (max-width: 480px) {
  .orderSummery_head {
    /* padding: 0 15px; */
  }

  .OrderSummeryProductDiv {
    padding: 0 20px;
  }

  .OrderSummeryItemDiv p.blackclr {
    background-color: #f1f1f1;
    padding: 10px 20px;
    /* font-size: 20px; */
  }

  

  .orderSummeryRightTop {
    padding-left: 20px;
    padding-right: 20px;
  }

  .orderSummeryRightTopC p {
    padding: 0 20px;
  }

  .orderSummeryCustomerDetailsArea .orderSummery_head {
    /* padding-left: 20px;
    padding-right: 20px; */
  }

  .orderSummeryCustomerDetailsInner {
    padding: 0 20px;
  }

  .orderSummeryIdentification h1 {
    padding-left: 20px;
    padding-right: 20px;
  }

  .left-font-header img {
    padding-left: 20px;
    padding-right: 20px;
  }

  .left-font-header {
    border: 0;
  }

  .orderSummeryRightTopC p.amountrow {
    background-color: #f1f1f1;
    padding: 10px 15px;
    border: 0;
    font-size: 20px;
  }
}

.css-1gtlbg0 {
  overflow: unset !important;
  padding-top: 0 !important;
}

.payment-summary-input {
  position: relative !important;
}

.css-m9glnp-MuiPaper-root-MuiDialog-paper {
  height: unset !important;
  width: unset !important;
}

.css-1hyl1h2 {
  height: unset !important;
  width: unset !important;
}

/* .css-1ujsas3{
    min-width: unset !important;
    padding: 0px !important;
} */

.BasicInfo-btn-padding {
  min-width: unset !important;
  padding: 0px !important;
}

.error-on-submit-register {
  left: 0 !important;
}

.payment-modal-button button {
  width: 48%;
  padding: 10px;
  font-size: 15px;
  font-family: QuicksandBold, 'Quicksand' !important;
  background-color: #fff;
  outline: none;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}

.payment-modal-outer-div .css-1t1j96h-MuiPaper-root-MuiDialog-paper {
  max-width: 500px !important;
}

.payment-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px 25px;
}

.payment-modal .payment-modal-content img {
  margin-bottom: 15px;
  width: 80px;
  height: auto;
}

.payment-modal .payment-modal-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 40px;
}

.payment-modal .payment-modal-button button {
  width: 48%;
  padding: 10px;
  font-size: 15px;
  font-family: QuicksandBold, 'Quicksand' !important;
  background-color: #fff;
  outline: none;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}

.payment-modal .payment-modal-button button:first-child {
  border: 1px solid #D0D5DD;
}

.payment-modal .payment-modal-content span {
  text-align: center;
  color: #212121;
  font-family: QuicksandBold, 'Quicksand' !important;
  font-size: 18px;
  padding: 0 10px;
}

.payment-modal .out-of-stock-products span {
  font-family: QuicksandBold, 'Quicksand' !important;
  font-size: 16px;
  align-self: start;
  margin-bottom: 5px;
  text-align: left;
}

.payment-modal-outer-div-card .css-1t1j96h-MuiPaper-root-MuiDialog-paper {
  width: 370px;
}

.css-uhb5lp {
  width: 370px !important;
}

.DatePicker-Debit-creadit-card {
  width: 100%;
  font-size: 12px !important;
  font-family: QuicksandMedium, 'Quicksand' !important;
  background: #ffffff !important;
  border: 1px solid #d3d3d3 !important;
  border-radius: 6px !important;
  /* height: 48px; */
}

.css-1rgmeur.Mui-error {
  color: unset !important;
}

.css-dvhgws::before {
  border-bottom: unset !important;
}

.css-dvhgws {
  background-color: unset !important;
}

.custom-date-picker-width {
  width: 100% !important;
  min-width: unset !important;
  /* Adjust width as needed */
}

.custom-date-picker-width
  .MuiOutlinedInput-root.Mui-focused
  .MuiOutlinedInput-notchedOutline {
  border-color: #000 !important;
  border-width: 1px !important;
}
.custom-date-picker-width
  .MuiOutlinedInput-root.Mui-error
  .MuiOutlinedInput-notchedOutline {
  border-color: rgba(0, 0, 0, 0.23) !important;
}

.custom-date-picker-width > div > input {
  /* font-family: QuicksandBold, 'Quicksand' !important; */
}

.custom-date-picker-width > label {
  font-family: QuicksandBold, 'Quicksand' !important;
}

.css-192l38i {
  display: block !important;
}

.input-field {
  width: 100% !important;
  position: relative !important;
  font-family: QuicksandMedium, 'Quicksand' !important;
}

.input-field
  .MuiOutlinedInput-root.Mui-focused
  .MuiOutlinedInput-notchedOutline {
  /* border-color: #000 !important; */
  border-color: #000 !important;
  border-width: 1px !important;
}
.input-field .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  /* border-color: #000 !important; */
  border-color: #000 !important;
  border-width: 1px !important;
}

.select-OnFocus.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #000 !important;
  border-width: 1px !important;
}

/* .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root .Mui-focused .MuiOutlinedInput-notchedOutline{
  border-color:  #000000 !important;
} */
/* .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #000000 !important;
  border-width: 1px !important;
} */

.input-field > div > input {
  /* font-family: QuicksandBold, 'Quicksand' !important; */
  font-family: QuicksandSemiBold, 'Quicksand' !important;
}

.input-field > label {
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  color: #000000 !important;
}

.form-select-formcontrol > label {
  /* font-family: QuicksandSemiBold, 'Quicksand' !important; */
}

.form-select-formcontrol > div > div {
  font-family: QuicksandBold, 'Quicksand' !important;
}

.form-select-formcontrol > div > input {
  font-family: QuicksandSemiBold, 'Quicksand' !important;
}

.delivery-payment-radio-button {
  display: flex !important;
  flex-direction: row !important;
}

.MuiPickersLayout-root {
  display: unset !important;
}

.MuiDialog-paper {
  min-width: 280px !important;
  /* width: 70% !important; */
}
@media (max-width: 480px) {
  .MuiDialog-paper {
    width: 70% !important;
  }
}
.MuiDateCalendar-root {
  width: 280px !important;
}
.MuiMonthCalendar-root {
  width: 280px !important;
}
.MuiDialogContent-root {
  overflow-x: hidden;
}
/* Track */
.MuiDialogContent-root::-webkit-scrollbar {
  width: 3px !important;
}
.MuiDialogContent-root::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey !important;
  border-radius: 10px !important;

  cursor: pointer !important;
}

/* Handle */
.MuiDialogContent-root::-webkit-scrollbar-thumb {
  background: #3e85f8 !important;
  border-radius: 10px !important;
  cursor: pointer !important;
  -webkit-transition: background 0.3s ease-in-out !important;
  transition: background 0.3s ease-in-out !important;
  outline: 1px solid #fff !important;
}

/* Handle on hover */
.MuiDateCalendar-root::-webkit-scrollbar-thumb:hover {
  background: #0a64f9 !important;
  cursor: pointer !important;
}

.MuiYearCalendar-root {
  width: 280px !important;
}

/* Track */
.MuiYearCalendar-root::-webkit-scrollbar {
  width: 3px;
}
.MuiYearCalendar-root::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;

  cursor: pointer;
}

/* Handle */
.MuiYearCalendar-root::-webkit-scrollbar-thumb {
  background: #3e85f8;
  border-radius: 10px;
  cursor: pointer;
  -webkit-transition: background 0.3s ease-in-out;
  transition: background 0.3s ease-in-out;
  outline: 1px solid #fff;
}

/* Handle on hover */
.MuiYearCalendar-root::-webkit-scrollbar-thumb:hover {
  background: #0a64f9;
  cursor: pointer !important;
}

/* .MuiDialogActions-root > button{
  border: 2px solid red !important; 
  background: #ffffff ;
  border: 1px solid #232323 !important;
  border-radius: 6px !important;
  color: #232323 !important;
  text-transform: capitalize !important;
  font-family: QuicksandBold, 'Quicksand' !important;
  width: 48%;
}
.MuiDialogActions-root.second-buttons > button {
  background: #0a64f9 !important;
  border: 2px solid #0a64f9 !important;
  color: #ffffff !important;
} */

.MuiFormLabel-root {
  color: #000 !important;
}

.MuiDialogActions-root {
  justify-content: space-around !important;
}

.topBarUserAndCartLogo > button {
  min-width: unset !important;
  padding: unset !important;
}

@media (min-width: 768px) {
  .loyality-points-para {
    /* margin-left: 0 !important; */
  }
}
@media (max-width: 480px) {
  .loyality-point-para-collpase {
    margin-left: 0 !important;
  }
}
.Log-in-as-Guest-div button {
  width: 325px !important;
}

.common-footer-div {
  margin-left: -47px !important;
  padding-left: 25px !important;
  margin-right: -46px !important;
  padding-right: 26px !important;
}
.common-footer-div > div > div {
  width: 90%;
}

@media (min-width: 768px) {
  .side-bar-and-order-section-footer {
    margin-left: 250px;
  }
}

.home_alert_div h3 {
  font-size: clamp(18px, 0.05px + 2.6783vw, 22px) !important;
}
.home_alert_div p {
  font-size: clamp(14px, 0.05px + 2.6783vw, 18px) !important;
}
.single-store-wishlist {
  /* min-height: calc(100vh - 137px) !important;  */
}

.lodding-image {
  width: 120px;
}

@media (max-width: 768px) {
  .lodding-image {
    width: 110px !important;
  }
  .OrderSummeryItemDiv p {
    margin-top: 20px;
  }
}
@media (max-width: 480px) {
  .lodding-image {
    width: 100px !important;
  }
}

.order-status-svg > svg {
  width: 100% !important;
  height: 100% !important;
}

@media (max-width: 480px) {
  .moreordersummary-container {
    background-color: #f1f1f1 !important;
  }
  .moreordersummary-container {
    padding: 0px 18px 0px 0px !important;
  }
}

.loaderarea {
  height: 80vh;
  display: flex;
  align-items: center;
  width: 100%;
    justify-content: center;
}

@media (max-width: 480px) {
  .refund-orderSummeryPage {
    margin-left: 15px;
    margin-left: 15px;
  }
}

.fa-lg {
  line-height: 0em !important;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/customPaymentCart.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,uDAAuD;EACzD;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;;;IAGE,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;;OAEK;EACL;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;AACF;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,mBAAmB;;EAEnB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,+CAAuC;EAAvC,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,eAAe;IACf,2BAA2B;EAC7B;;EAEA;;;OAGK;;EAEL;;OAEK;;EAEL;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA,gEAAgE;;EAEhE;IACE,WAAW;IACX,mBAAmB;IACnB,0FAA0F;EAC5F;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf;yCACqC;EACvC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;;;EAGE,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;;;EAGE,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,OAAO;EACP,8DAA8D;EAC9D,gBAAgB;AAClB;;AAEA;;;;GAIG;;AAEH;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;EACvB;;;;EAIA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE;0BACsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;;;GAGG;;AAEH;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,kDAAkD;EAClD,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,kDAAkD;EAClD,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kDAAkD;EAClD,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,oDAAoD;EACpD,8BAA8B;EAC9B,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;;EAGE,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,oDAAoD;AACtD;;AAEA;;;EAGE,mCAAmC;EACnC,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;GAEG;AACH;;;GAGG;;AAEH;EACE,wDAAwD;EACxD,sDAAsD;AACxD;;AAEA;EACE,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA,UAAU;AACV;EACE,qBAAqB;AACvB;AACA;EACE,yCAAyC;EACzC,8BAA8B;;EAE9B,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,0BAA0B;EAC1B,0DAAkD;EAAlD,kDAAkD;EAClD,kCAAkC;AACpC;;AAEA,oBAAoB;AACpB;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,mBAAmB;;EAEnB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,+CAAuC;EAAvC,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;;;;;;;;;;;;;GAcG;;AAEH;EACE,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,0DAA0D;AAC5D;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,iDAAiD;AACnD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;IACT,uBAAuB;AAC3B;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["@media (max-width: 1188px) {\n  .payment-stepper-cart {\n    width: 80%;\n  }\n}\n\n@media (max-width: 1173px) {\n  .payment-stepper-cart {\n    width: 90%;\n  }\n\n  .quickvee-payment-component-content {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n@media (max-width: 1035px) {\n  .payment-stepper-cart {\n    width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .payment-stepper-cart {\n    display: flex !important;\n    flex-wrap: wrap;\n  }\n\n  .payment-stepper-cart > .payment-stepper-wishlist-item {\n    width: 100%;\n  }\n\n  .payment-stepper-cart > .payment-stepper-checkout-item {\n    width: 100%;\n    margin-bottom: 20px;\n  }\n\n  .payment-stepper-cart > .payment-stepper-customer-detail-section {\n    width: 100%;\n  }\n\n  .payment-all-cart-items.overflowed {\n    padding: 0;\n    overflow: hidden;\n  }\n\n  .quickvee-payement-stepper > span {\n    font-size: clamp(12px, 2px + 2.1783vw, 18px) !important;\n  }\n\n  .quickvee-payement-stepper {\n    padding: 20px 0px;\n    /* margin-bottom: 20px; */\n  }\n\n  .payment-stepper-cart\n    > .payment-stepper-wishlist-item\n    > .payment-all-cart-items {\n    height: unset !important;\n    max-height: unset !important;\n  }\n\n  .payment-stepper-cart > .payment-stepper-customer-detail-section {\n    border-right: 0;\n  }\n\n  /* .custom-file-upload-input {\n        width: 90% !important;\n    } */\n  .payment-delivery-payment-info-section {\n    height: unset;\n  }\n\n  .payment-stepper-cart > .payment-stepper-wishlist-item {\n    border-right: 0;\n  }\n\n  #modal-modal-description {\n    overflow-x: unset;\n  }\n\n  .payment-stepper-cart > .payment-stepper-customer-detail-section {\n    padding: 0;\n  }\n\n  .payment-delivery-section {\n    margin-bottom: 20px;\n  }\n  .payment-stepper-checkout-item {\n    padding-top: 10px !important;\n  }\n\n  .payment-stepper-customer-detail-section {\n    padding: 0 20px !important;\n  }\n\n  .payment-stepper-cart\n    > .payment-stepper-wishlist-item\n    > .payment-all-cart-items {\n    margin: 0 !important;\n  }\n\n  .payment-stepper-single-billing-info-detail {\n    padding-top: 20px;\n  }\n\n  .payment-delivery-payment-info-section {\n    margin-bottom: 10px;\n  }\n\n  .profile-page-user-data-button {\n    padding-left: 11px;\n  }\n\n  .payment-card-details-add-section > div {\n    /* width: 100% !important; */\n    margin-bottom: 15px;\n  }\n\n  .card-expiry-date {\n    max-width: 100% !important;\n    bottom: -17px !important;\n  }\n}\n\n/* add css by priya */\n.MuiPaper-root::-webkit-scrollbar {\n  width: 3px;\n}\n.MuiPaper-root::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px grey;\n  border-radius: 10px;\n\n  cursor: pointer;\n}\n\n/* Handle */\n.MuiPaper-root::-webkit-scrollbar-thumb {\n  background: #3e85f8;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.3s ease-in-out;\n  outline: 1px solid #fff;\n}\n\n/* Handle on hover */\n.MuiPaper-root::-webkit-scrollbar-thumb:hover {\n  background: #0a64f9;\n  cursor: pointer !important;\n}\n\n@media (max-width: 604px) {\n  .payment-card-details-add-section > div {\n    width: 100% !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .top-content p {\n    font-family: QuicksandBold !important;\n    font-size: 16px;\n    font-weight: 400 !important;\n  }\n\n  /* .payment-card-details-add-section>div{\n        width: 100% !important;\n        margin-bottom: 15px;\n    } */\n\n  /* .css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input {\n        padding: 10px 10px !important;\n    } */\n\n  .MobileViewPaymentWishlist-option-title {\n    font-weight: 500 !important;\n    padding-left: 5px;\n    margin-bottom: 5px;\n  }\n\n  .payment-stepper-cart > .payment-stepper-wishlist-item {\n    width: 100%;\n  }\n\n  /* font-size: clamp(12px, 0.05px + 5.1783vw, 20px) !important; */\n\n  .payment-stepper-cart > .payment-stepper-checkout-item {\n    width: 100%;\n    margin-bottom: 20px;\n    /* box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px; */\n  }\n\n  .payment-stepper-cart > .payment-stepper-wishlist-item {\n    padding: 0;\n  }\n\n  .payment-page-wishlist-cart-items {\n    margin-top: 5px;\n    box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px,\n      rgba(17, 17, 26, 0.05) 0px 8px 32px;\n  }\n\n  .quickvee-payment-component-content {\n    padding: 0;\n  }\n\n  .payment-page-wishlist-cart-items {\n    border-radius: 0;\n    border: 0;\n  }\n\n  .id-card-detail-image {\n    width: 100% !important;\n  }\n\n  .custom-file-upload-input {\n    width: 100% !important;\n  }\n\n  .payment-billing-inputs-div {\n    display: flex !important;\n    flex-wrap: wrap !important;\n  }\n\n  .payment-billing-input-outer-div {\n    width: 100%;\n  }\n\n  .payment-billing-city-state-update-inputs {\n    display: flex !important;\n    gap: 2 !important;\n  }\n\n  .payment-billing-city-state-update-inputs > div:first-child {\n    margin-right: 10px;\n    width: 100%;\n  }\n\n  .payment-billing-input-outer-div {\n    position: relative;\n    margin-top: 0px !important;\n    margin-bottom: 15px;\n  }\n\n  .quickvee-payement-stepper > span {\n    margin: 0 5px;\n  }\n\n  .css-10botns-MuiInputBase-input-MuiFilledInput-input {\n    padding-top: 20px;\n  }\n}\n\n.payment-page-wishlist-item-content > .middle-content {\n  width: 100% !important;\n}\n\n.payment-page-wishlist-item-content\n  > .middle-content\n  > .increment-decremnt-button\n  > span {\n  margin: unset;\n}\n\n.payment-page-wishlist-item-content\n  > .middle-content\n  > .increment-decremnt-button\n  button:disabled {\n  background: #80aef7;\n}\n\n.payment-page-wishlist-item-content\n  > .middle-content\n  > .increment-decremnt-button\n  button {\n  border: none;\n  background: #0a64f9;\n  border-radius: 4px;\n  color: #fff;\n  padding: 6px 8px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.payment-page-wishlist-item-content > .bottom-dropdowns-for-categories > div {\n  margin-bottom: 10px !important;\n  padding: 0px 3px;\n  margin-right: 0;\n  width: unset() !important;\n  padding: 0 5px !important;\n}\n\n.billing-info-delivery-address-update-form > div:nth-child(2) {\n  margin: 0px 0px !important;\n}\n\n.payment-delivery-address-section\n  > .bottom-section-of-payment-delivery-address\n  > .payment-delivery-single-delivery-address {\n  margin: 4px -4px !important;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-checkout-item\n  > .payment-stepper-checkout-item-top {\n  font-size: clamp(12px, 0.05px + 4.1783vw, 20px) !important;\n}\n\n.payment-billing-customer-form > h1 {\n  margin-bottom: 12px;\n  font-size: clamp(12px, 0.05px + 4.1783vw, 20px) !important;\n}\n\n.payment-delivery-section > span {\n  font-size: clamp(12px, 0.05px + 4.1783vw, 20px) !important;\n}\n\n.payment-delivery-payment-info-section > span {\n  font-size: clamp(12px, 0.05px + 4.1783vw, 20px) !important;\n}\n\n.payment-delivery-address-section\n  > .head-section-of-payment-delivery-address\n  > span {\n  font-size: clamp(12px, 0.05px + 4.1783vw, 20px) !important;\n}\n\n.payment-radio-heading span:nth-child(2) {\n  font-size: clamp(12px, 0.05px + 4.1783vw, 16px) !important;\n}\n\n.css-ahj2mt-MuiTypography-root {\n  /* font-size: clamp(12px, 0.05px + 3.1783vw, 16px) !important; */\n}\n\n.modal-main-button {\n  font-size: clamp(12px, 0.05px + 3.1783vw, 14px) !important;\n}\n\n.select-delivery-hour-and-date label {\n  /* font-size: clamp(14px, 0.05px + 3.1783vw, 14px) !important; */\n}\n\n.modal-form-single-input label {\n  font-size: clamp(10px, 0.05px + 3.1783vw, 14px) !important;\n}\n\n.css-1ff8729-MuiInputBase-root-MuiFilledInput-root {\n  font-size: clamp(14px, 0.05px + 2.6783vw, 14px) !important;\n}\n\n.stateDropdown .modal-form-single-input {\n  font-size: clamp(10px, 0.05px + 2.6783vw, 14px) !important;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-checkout-item\n  > .payment-stepper-checkout-content\n  > .quickvee-checkout-final-amount {\n  margin: 15px 0 15px 0 !important;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-wishlist-item\n  > .payment-stepper-wishlist-item-topper {\n  margin-top: 20px;\n}\n\n.payment-stepper-wishlist-item {\n  margin-bottom: 10px;\n}\n\n@media (min-width: 768px) {\n  .payment-stepper-checkout-item-top {\n    margin-top: 20px;\n  }\n}\n\n.payment-billing-input-outer-div {\n  position: relative;\n  margin-top: 0px !important;\n  margin-bottom: 15px;\n}\n\n.input-error {\n  position: absolute;\n  bottom: -20px;\n  left: 0;\n  padding-left: 0;\n  /* width: 80px; */\n  /* padding-right: 30px; */\n  height: 15px;\n}\n\n.payment-billing-input-outer-div-for-all {\n  margin: 0 !important;\n}\n\n.top-bar-button {\n  padding-left: 19px !important;\n  min-width: 0 !important;\n  padding: 0 !important;\n}\n\n.css-1e6y48t-MuiButtonBase-root-MuiButton-root {\n  /* padding: 8.76px 0px !important; */\n  /* height: 44px; */\n}\n\n.payment-card-details-add-section-single-item {\n  position: relative !important;\n}\n\n.cvv {\n  position: relative !important;\n}\n\n.card-expiry-date {\n  position: absolute;\n  /* bottom: -30px; */\n  left: 0;\n  /* font-size: clamp(2px, 0.05px + 2.8783vw, 8px) !important; */\n  max-width: 100px;\n}\n\n/* @media (max-width: 392px) {\n    .cvv-input{\n        bottom: -29px;\n    }\n} */\n\n.choose-date-on-payment {\n  position: relative !important;\n}\n\n.choose-time-on-payment {\n  position: relative !important;\n}\n\n.css-1xhypcz-MuiStack-root > .MuiTextField-root {\n  /* min-width: unset !important; */\n}\n\n.custom-file-upload-input {\n  position: relative;\n}\n\n.image_input_error {\n  left: 0;\n}\n\n@media (max-width: 480px) {\n  .orderSummery_head {\n    /* padding: 0 15px; */\n  }\n\n  .OrderSummeryProductDiv {\n    padding: 0 20px;\n  }\n\n  .OrderSummeryItemDiv p.blackclr {\n    background-color: #f1f1f1;\n    padding: 10px 20px;\n    /* font-size: 20px; */\n  }\n\n  \n\n  .orderSummeryRightTop {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .orderSummeryRightTopC p {\n    padding: 0 20px;\n  }\n\n  .orderSummeryCustomerDetailsArea .orderSummery_head {\n    /* padding-left: 20px;\n    padding-right: 20px; */\n  }\n\n  .orderSummeryCustomerDetailsInner {\n    padding: 0 20px;\n  }\n\n  .orderSummeryIdentification h1 {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .left-font-header img {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .left-font-header {\n    border: 0;\n  }\n\n  .orderSummeryRightTopC p.amountrow {\n    background-color: #f1f1f1;\n    padding: 10px 15px;\n    border: 0;\n    font-size: 20px;\n  }\n}\n\n.css-1gtlbg0 {\n  overflow: unset !important;\n  padding-top: 0 !important;\n}\n\n.payment-summary-input {\n  position: relative !important;\n}\n\n.css-m9glnp-MuiPaper-root-MuiDialog-paper {\n  height: unset !important;\n  width: unset !important;\n}\n\n.css-1hyl1h2 {\n  height: unset !important;\n  width: unset !important;\n}\n\n/* .css-1ujsas3{\n    min-width: unset !important;\n    padding: 0px !important;\n} */\n\n.BasicInfo-btn-padding {\n  min-width: unset !important;\n  padding: 0px !important;\n}\n\n.error-on-submit-register {\n  left: 0 !important;\n}\n\n.payment-modal-button button {\n  width: 48%;\n  padding: 10px;\n  font-size: 15px;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  background-color: #fff;\n  outline: none;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n}\n\n.payment-modal-outer-div .css-1t1j96h-MuiPaper-root-MuiDialog-paper {\n  max-width: 500px !important;\n}\n\n.payment-modal {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 20px 25px;\n}\n\n.payment-modal .payment-modal-content img {\n  margin-bottom: 15px;\n  width: 80px;\n  height: auto;\n}\n\n.payment-modal .payment-modal-button {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-top: 40px;\n}\n\n.payment-modal .payment-modal-button button {\n  width: 48%;\n  padding: 10px;\n  font-size: 15px;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  background-color: #fff;\n  outline: none;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n}\n\n.payment-modal .payment-modal-button button:first-child {\n  border: 1px solid #D0D5DD;\n}\n\n.payment-modal .payment-modal-content span {\n  text-align: center;\n  color: #212121;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  font-size: 18px;\n  padding: 0 10px;\n}\n\n.payment-modal .out-of-stock-products span {\n  font-family: QuicksandBold, 'Quicksand' !important;\n  font-size: 16px;\n  align-self: start;\n  margin-bottom: 5px;\n  text-align: left;\n}\n\n.payment-modal-outer-div-card .css-1t1j96h-MuiPaper-root-MuiDialog-paper {\n  width: 370px;\n}\n\n.css-uhb5lp {\n  width: 370px !important;\n}\n\n.DatePicker-Debit-creadit-card {\n  width: 100%;\n  font-size: 12px !important;\n  font-family: QuicksandMedium, 'Quicksand' !important;\n  background: #ffffff !important;\n  border: 1px solid #d3d3d3 !important;\n  border-radius: 6px !important;\n  /* height: 48px; */\n}\n\n.css-1rgmeur.Mui-error {\n  color: unset !important;\n}\n\n.css-dvhgws::before {\n  border-bottom: unset !important;\n}\n\n.css-dvhgws {\n  background-color: unset !important;\n}\n\n.custom-date-picker-width {\n  width: 100% !important;\n  min-width: unset !important;\n  /* Adjust width as needed */\n}\n\n.custom-date-picker-width\n  .MuiOutlinedInput-root.Mui-focused\n  .MuiOutlinedInput-notchedOutline {\n  border-color: #000 !important;\n  border-width: 1px !important;\n}\n.custom-date-picker-width\n  .MuiOutlinedInput-root.Mui-error\n  .MuiOutlinedInput-notchedOutline {\n  border-color: rgba(0, 0, 0, 0.23) !important;\n}\n\n.custom-date-picker-width > div > input {\n  /* font-family: QuicksandBold, 'Quicksand' !important; */\n}\n\n.custom-date-picker-width > label {\n  font-family: QuicksandBold, 'Quicksand' !important;\n}\n\n.css-192l38i {\n  display: block !important;\n}\n\n.input-field {\n  width: 100% !important;\n  position: relative !important;\n  font-family: QuicksandMedium, 'Quicksand' !important;\n}\n\n.input-field\n  .MuiOutlinedInput-root.Mui-focused\n  .MuiOutlinedInput-notchedOutline {\n  /* border-color: #000 !important; */\n  border-color: #000 !important;\n  border-width: 1px !important;\n}\n.input-field .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  /* border-color: #000 !important; */\n  border-color: #000 !important;\n  border-width: 1px !important;\n}\n\n.select-OnFocus.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #000 !important;\n  border-width: 1px !important;\n}\n\n/* .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root .Mui-focused .MuiOutlinedInput-notchedOutline{\n  border-color:  #000000 !important;\n} */\n/* .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #000000 !important;\n  border-width: 1px !important;\n} */\n\n.input-field > div > input {\n  /* font-family: QuicksandBold, 'Quicksand' !important; */\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n}\n\n.input-field > label {\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  color: #000000 !important;\n}\n\n.form-select-formcontrol > label {\n  /* font-family: QuicksandSemiBold, 'Quicksand' !important; */\n}\n\n.form-select-formcontrol > div > div {\n  font-family: QuicksandBold, 'Quicksand' !important;\n}\n\n.form-select-formcontrol > div > input {\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n}\n\n.delivery-payment-radio-button {\n  display: flex !important;\n  flex-direction: row !important;\n}\n\n.MuiPickersLayout-root {\n  display: unset !important;\n}\n\n.MuiDialog-paper {\n  min-width: 280px !important;\n  /* width: 70% !important; */\n}\n@media (max-width: 480px) {\n  .MuiDialog-paper {\n    width: 70% !important;\n  }\n}\n.MuiDateCalendar-root {\n  width: 280px !important;\n}\n.MuiMonthCalendar-root {\n  width: 280px !important;\n}\n.MuiDialogContent-root {\n  overflow-x: hidden;\n}\n/* Track */\n.MuiDialogContent-root::-webkit-scrollbar {\n  width: 3px !important;\n}\n.MuiDialogContent-root::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px grey !important;\n  border-radius: 10px !important;\n\n  cursor: pointer !important;\n}\n\n/* Handle */\n.MuiDialogContent-root::-webkit-scrollbar-thumb {\n  background: #3e85f8 !important;\n  border-radius: 10px !important;\n  cursor: pointer !important;\n  transition: background 0.3s ease-in-out !important;\n  outline: 1px solid #fff !important;\n}\n\n/* Handle on hover */\n.MuiDateCalendar-root::-webkit-scrollbar-thumb:hover {\n  background: #0a64f9 !important;\n  cursor: pointer !important;\n}\n\n.MuiYearCalendar-root {\n  width: 280px !important;\n}\n\n/* Track */\n.MuiYearCalendar-root::-webkit-scrollbar {\n  width: 3px;\n}\n.MuiYearCalendar-root::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px grey;\n  border-radius: 10px;\n\n  cursor: pointer;\n}\n\n/* Handle */\n.MuiYearCalendar-root::-webkit-scrollbar-thumb {\n  background: #3e85f8;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.3s ease-in-out;\n  outline: 1px solid #fff;\n}\n\n/* Handle on hover */\n.MuiYearCalendar-root::-webkit-scrollbar-thumb:hover {\n  background: #0a64f9;\n  cursor: pointer !important;\n}\n\n/* .MuiDialogActions-root > button{\n  border: 2px solid red !important; \n  background: #ffffff ;\n  border: 1px solid #232323 !important;\n  border-radius: 6px !important;\n  color: #232323 !important;\n  text-transform: capitalize !important;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  width: 48%;\n}\n.MuiDialogActions-root.second-buttons > button {\n  background: #0a64f9 !important;\n  border: 2px solid #0a64f9 !important;\n  color: #ffffff !important;\n} */\n\n.MuiFormLabel-root {\n  color: #000 !important;\n}\n\n.MuiDialogActions-root {\n  justify-content: space-around !important;\n}\n\n.topBarUserAndCartLogo > button {\n  min-width: unset !important;\n  padding: unset !important;\n}\n\n@media (min-width: 768px) {\n  .loyality-points-para {\n    /* margin-left: 0 !important; */\n  }\n}\n@media (max-width: 480px) {\n  .loyality-point-para-collpase {\n    margin-left: 0 !important;\n  }\n}\n.Log-in-as-Guest-div button {\n  width: 325px !important;\n}\n\n.common-footer-div {\n  margin-left: -47px !important;\n  padding-left: 25px !important;\n  margin-right: -46px !important;\n  padding-right: 26px !important;\n}\n.common-footer-div > div > div {\n  width: 90%;\n}\n\n@media (min-width: 768px) {\n  .side-bar-and-order-section-footer {\n    margin-left: 250px;\n  }\n}\n\n.home_alert_div h3 {\n  font-size: clamp(18px, 0.05px + 2.6783vw, 22px) !important;\n}\n.home_alert_div p {\n  font-size: clamp(14px, 0.05px + 2.6783vw, 18px) !important;\n}\n.single-store-wishlist {\n  /* min-height: calc(100vh - 137px) !important;  */\n}\n\n.lodding-image {\n  width: 120px;\n}\n\n@media (max-width: 768px) {\n  .lodding-image {\n    width: 110px !important;\n  }\n  .OrderSummeryItemDiv p {\n    margin-top: 20px;\n  }\n}\n@media (max-width: 480px) {\n  .lodding-image {\n    width: 100px !important;\n  }\n}\n\n.order-status-svg > svg {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n@media (max-width: 480px) {\n  .moreordersummary-container {\n    background-color: #f1f1f1 !important;\n  }\n  .moreordersummary-container {\n    padding: 0px 18px 0px 0px !important;\n  }\n}\n\n.loaderarea {\n  height: 80vh;\n  display: flex;\n  align-items: center;\n  width: 100%;\n    justify-content: center;\n}\n\n@media (max-width: 480px) {\n  .refund-orderSummeryPage {\n    margin-left: 15px;\n    margin-left: 15px;\n  }\n}\n\n.fa-lg {\n  line-height: 0em !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
